export const VideoCallSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33341 5H12.5001C13.4167 5 14.1667 5.75 14.1667 6.66667V13.3333C14.1667 14.25 13.4167 15 12.5001 15H3.33341C2.41675 15 1.66675 14.25 1.66675 13.3333V6.66667C1.66675 5.75 2.41675 5 3.33341 5Z"
        fill="white"
      />
      <path
        d="M18.3334 14.5837L14.1667 12.0837V7.91699L18.3334 5.41699V14.5837Z"
        fill="white"
      />
    </svg>
  )
}
